import {React, observer, classNames, _} from '@api'
import {DetailsViewFieldConfig} from '@stores'
import {useFieldRendererStore} from '@design-board/stores'
import {useAsync} from 'react-use'
import * as css from './EnumTextRenderer.css'

export const EnumTextRenderer = observer<{ valAsString: string, field: DetailsViewFieldConfig, className?: string }>(function EnumTextRenderer({valAsString, field, className}) {
  const store = useFieldRendererStore(),
    {strings, value: {val}, catalogField, c8} = store,
    {loading, value: enumList} = useAsync(async () => await c8.getEnumValues(field ?? catalogField)),
    enumValue = enumList?.length && valAsString ? enumList?.find((e) => e?.name === valAsString) : null
  // Todo: need to work on showing displayname instead of name from c8 enumertaion as backend return name and description only
  return <span className={classNames(css.root, className)}>
        {`${_.isNull(enumValue) || loading ? strings.emptyLabel : enumValue?.description ? enumValue?.description : strings.emptyLabel}${catalogField?.def?.suffix ?? ''}`}
    </span>
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/EnumTextRenderer.tsx